import { createContext } from "react";
import { Subscription } from "types/Models/subscription";

export const SubscriptionsContext = createContext<{
  subscriptions: Subscription[];
}>({ subscriptions: [] });
